module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-RegularItalic-110309b5ab5a61625164eca8fd24e39d.woff";